import {td_ginkoia_price, td_ginkoia_price_update} from "../../api/td_ginkoia_price.api"


const getDefaultState = () => {
    return {
        ginkoia_prices: []
    }
}


// initial state
const state = getDefaultState()

const mutations = {
    set_ginkoia_prices(state, ginkoia_prices) {
        state.ginkoia_prices = ginkoia_prices
    },
    resetState (state) {
        Object.assign(state, getDefaultState())
        console.log("GRB 1");
    }
}

const actions = {
    load_ginkoia_prices(context) {

        return new Promise((resolve, reject) =>
            td_ginkoia_price()
                .then((response) => {
                    if (response.status == '200') {
                        let ginkoia_prices = response.data;
                        context.commit('set_ginkoia_prices', ginkoia_prices)
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    },
    update_td_ginkoia_price({state, commit}, td_ginkoia_price)
    {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            td_ginkoia_price_update(td_ginkoia_price)
                .then((response) => {
                    if (response.status == '200') {
                        // Si OK on commit le state
                        // commit('update_order_detail',order_detail);
                        this._vm.$message({
                            message: 'Mise à jour OK',
                            type: 'success',center: true
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        )
    }
}


const getters = {
    get_ginkoia_prices(state) {
        return state.ginkoia_prices
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}